'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const CurrencyColors = {
    EUR: '#0B0BA7',
    ZWD: '#0e9a68',
    GBP: '#df071c',
    USD: '#ce7e38',
    HUF: '#48dc20',
    SEK: '#00bcb0',
    DKK: '#259900',
    CHF: '#c98174',
    BGN: '#00ca08',
    AUD: '#8c8c50',
    AED: '#1c1cd0',
    NZD: '#53afbc',
    PLN: '#54AF4F',
    NOK: '#A64CCA',
    SAR: '#a85080',
    JPY: '#bd6954',
    CAD: '#980020',
    ARS: '#77772c',
    BOB: '#3612b8',
    BRL: '#4bc78c',
    CLP: '#e54d04',
    CNY: '#035b6c',
    COP: '#0a6228',
    CZK: '#238DA7',
    EGP: '#6a2a88',
    GEL: '#046c90',
    HKD: '#024698',
    HRK: '#33274c',
    IDR: '#956504',
    ILS: '#cd4d64',
    INR: '#dbab2c',
    ISK: '#0e2e18',
    KRW: '#9f277c',
    KWD: '#c29a68',
    LTL: '#81d5a4',
    MNT: '#2b0bbc',
    MOP: '#3262c8',
    MXN: '#7151e4',
    MYR: '#780850',
    PEN: '#58bc80',
    PHP: '#6d3104',
    PYG: '#e4a830',
    QAR: '#105060',
    RON: '#4612c8',
    RUB: '#703c20',
    SGD: '#d22a78',
    THB: '#ad00e4',
    TRY: '#03776c',
    TWD: '#269a08',
    UAH: '#50a000',
    UYU: '#0808d0',
    VEF: '#406c90',
    ZAR: '#645000',
};

exports["default"] = CurrencyColors;
